import {
  styled,
  Grid as GridBase,
  Box,
  Table,
  TableRow,
  TableCell,
  TableHead,
} from "@mui/material";

export const GridContainer = styled((props) => (
  <GridBase {...props} container />
))`
  &.MuiGrid-container {
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const PeriodicBillingReportFormRootArea = styled((props) => (
  <GridContainer {...props} />
))``;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${(props) => props.flexDirection || "column"};
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const DataCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(3),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  border: `1px solid ${theme.palette.divider}`,
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
    transform: "translateY(-2px)",
  },
}));

export const DataCardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  borderBottom: `2px solid ${theme.palette.primary.main}`,
}));

export const DataCardTitle = styled(Box)(({ theme }) => ({
  fontSize: "1.1rem",
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginLeft: theme.spacing(1),
}));

export const ReportTable = styled(Table)(({ theme }) => ({
  width: "100%",
  "& .MuiTableCell-root": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.5, 2),
  },
  "& .MuiTableHead-root .MuiTableCell-root": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    fontSize: "0.875rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    padding: theme.spacing(2),
  },
  "& .MuiTableBody-root .MuiTableCell-root": {
    fontSize: "0.875rem",
    padding: theme.spacing(1.5, 2),
  },
}));

export const ReportTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.blokko.taglineMist,
  },
  "&:hover": {
    backgroundColor: theme.palette.blokko.tableRowHover,
  },
}));

export const ReportTableHeader = styled(TableHead)(({ theme }) => ({
  "& .MuiTableCell-root": {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    fontSize: "0.875rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
}));

export const AmountCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  textAlign: "right",
}));

export const StatusCell = styled(TableCell)(({ theme, status }) => ({
  fontWeight: 500,
  color:
    status === "E"
      ? theme.palette.success.main
      : status === "P"
      ? theme.palette.warning.main
      : theme.palette.text.secondary,
}));

